(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-dashboard"]) return;
  try {
    
  const tabs = document.querySelectorAll('.clack-account .tab-btn');
  const panels = {
    orders: document.getElementById('panel-orders'),
    profile: document.getElementById('panel-profile'),
    addresses: document.getElementById('panel-addresses'),
  };
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      Object.values(panels).forEach(function (p) { if (p) p.classList.remove('active'); });
      tab.setAttribute('aria-selected', 'true');
      if (panels[tab.dataset.tab]) panels[tab.dataset.tab].classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
